import React from "react";
import { Helmet } from "react-helmet-async";
import Details from "../components/Details";
import Footer from "../components/Footer/Footer";

const Contact = () => {
  const baseUrl = "https://www.peoplefortech.com";
  const pageUrl = `${baseUrl}/sammy/contact`;
  
  return (
    <>
      <Helmet>
        {/* Meta tags básicos */}
        <title>Sammy - Contacto</title>
        <meta name="description" content="Contáctanos en Sammy. Escríbenos y te responderemos pronto." />
        <link rel="canonical" href={pageUrl} />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:title" content="Sammy - Contacto" />
        <meta property="og:description" content="Contáctanos en Sammy. Escríbenos y te responderemos pronto." />
        
        {/* Schema.org JSON-LD para SEO de IA */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ContactPage",
            "name": "Sammy - Contacto",
            "description": "Contáctanos en Sammy. Escríbenos y te responderemos pronto.",
            "url": pageUrl,
            "mainEntity": {
              "@type": "Organization",
              "name": "Sammy",
              "url": `${baseUrl}/sammy/home`,
              "contactPoint": {
                "@type": "ContactPoint",
                "contactType": "Customer Service"
              }
            }
          })}
        </script>
      </Helmet>
      <Details />
      <Footer />
    </>
  );
};

export default Contact;
